module.exports = __webpack_public_path__ + "img/ttd-wd1.ecd35ccf.png";